module.exports = __webpack_public_path__ + "res/24-img_game_bg_m.696a6bc6f0e0db29470ae819bd6cd9d6.png";